export const clientsData = [
	[{ name: 'nodejs' }],
	[{ name: 'redux' }, { name: 'html' }],
	[{ name: 'react' }, { name: '1337' }, { name: 'css' }],
	[{ name: 'c' }, { name: 'php' }],
	[{ name: 'js' }],
];
